export default () => ({
  trigger: {
    name: 'mini_product_page.view_reviews',
    params: {},
  },
  config: {
    event: {
      name: 'view_content',
      params: {
        sub_feature: null,
        content: null,
        index: null,
        total_indices: null,
      },
    },
    nonInt: true,
  },
});
